import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { UpgradeButton } from '@playbookux/playbook-web-core';
import {
  FlexContainer,
  ServiceIconContainer,
  ServiceIcon,
  ServiceName,
  ServiceDescriptionList,
  ServiceListItem,

  ServiceContainer,

} from './styles';
import { mapServiceDetails } from './constants';
import { PathfixConnectButton } from './pathfix-buttons/connect-button';
import { ErrorMessage } from '../../../../../core/components/modal-with-input/styles';
import { registerFunctions } from '../../../../../core/hooks/use-function-handler';

const ServiceSegment = (props) => {
  const {
    service,
    onUpgrade,
    onConnect,
    onDisconnect,
    hasRequiredPlan,
    companyMemberId,
    companyServiceIntegrationStatus,
  } = props;

  const { name: serviceName } = service;

  const companyServiceIntegrationStatusPlaceholder = companyServiceIntegrationStatus && companyServiceIntegrationStatus !== 'connected';

  const [integrationError, setIntegrationError] = useState(companyServiceIntegrationStatusPlaceholder);

  const serviceDetails = mapServiceDetails[serviceName] || {};

  const { icon, displayName, descriptionList } = serviceDetails;

  const handleUpgrade = () => {
    setIntegrationError(false);
    onUpgrade();
  };

  const handleConnect = () => {
    setIntegrationError(false);
    onConnect();
  };

  const handleDisconnect = () => {
    setIntegrationError(false);
    onDisconnect();
  };

  const handleIntegrationError = () => {
    setIntegrationError(true);
  };

  registerFunctions('integrations', {
    func1: handleIntegrationError,
  });

  return (
    <>
      {integrationError && (
        <ErrorMessage>
          There was an error connecting. Please contact chat support or try again.
        </ErrorMessage>
      )}
      {hasRequiredPlan
        ? (
          <PathfixConnectButton
            descriptions={descriptionList}
            endUserId={companyMemberId}
            onConnect={handleConnect}
            onDisconnect={handleDisconnect}
          />
        )
        : (
          <ServiceContainer>
            <FlexContainer>
              <ServiceIconContainer>
                <ServiceIcon src={icon.src} alt={icon.alt} />
              </ServiceIconContainer>
              <div>
                <ServiceName as="h3">{displayName}</ServiceName>
                <ServiceDescriptionList>
                  {descriptionList.map((description) => (
                    <ServiceListItem key={description}>{description}</ServiceListItem>
                  ))}
                </ServiceDescriptionList>
              </div>
            </FlexContainer>
            <UpgradeButton
              onClick={handleUpgrade}
              pointer
            >
              Upgrade
            </UpgradeButton>
          </ServiceContainer>
        )}
    </>
  );
};

const serviceShape = PropTypes.shape({
  name: PropTypes.string,
  id: PropTypes.string,
  category: PropTypes.string,
  providerName: PropTypes.string,
});

ServiceSegment.propTypes = {
  service: serviceShape.isRequired,
  onUpgrade: PropTypes.func.isRequired,
  onConnect: PropTypes.func.isRequired,
  onDisconnect: PropTypes.func.isRequired,
  hasRequiredPlan: PropTypes.bool.isRequired,
  companyMemberId: PropTypes.string.isRequired,
  companyServiceIntegrationStatus: PropTypes.string.isRequired,
};

export default ServiceSegment;
